// ProtectedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const guestInfoStr = localStorage.getItem('guest-info');
  const guestInfo = guestInfoStr ? JSON.parse(guestInfoStr) : null;
  const location = useLocation();
  const redirectAfterAuth = `${location.pathname}${location.search}`;

  // Only redirect if there is absolutely no way to access the app
  if (!isAuthenticated && !guestInfo) {
    return (
      <Navigate
        to={`/auth?redirectAfterAuth=${encodeURIComponent(redirectAfterAuth)}`}
        replace
      />
    );
  }

  // If guestInfo exists (even if for a different session), allow the route.
  // The page (PlanningSessionPage) will rejoin / rehydrate if needed.
  return children;
};
